
const digest = '569a2fc7df31eea9b6e41033ff8b31b4074c702f95a855d75d9bb5d9ed4a6c7b';
const classes = {"wrapper":"_wrapper_1c7i7_1","options":"_options_1c7i7_7","list":"_list_1c7i7_18","item":"_item_1c7i7_44","content":"_content_1c7i7_53","a":"_a_1c7i7_60","title":"_title_1c7i7_65","status":"_status_1c7i7_70","b":"_b_1c7i7_74","info":"_info_1c7i7_80","patientButton":"_patientButton_1c7i7_90","controls":"_controls_1c7i7_97","linkBlue":"_linkBlue_1c7i7_108","linkRed":"_linkRed_1c7i7_115"};
const css = `._wrapper_1c7i7_1 {
  flex-grow: 1;
  height: 100%;
  overflow-y: hidden;
  font-family: "Rubik", sans-serif;
}
._wrapper_1c7i7_1 ._options_1c7i7_7 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  padding: 16px 24px;
  border: 1px solid #eaedf3;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  border-top: 0;
  justify-content: flex-end;
}
._wrapper_1c7i7_1 ._list_1c7i7_18 {
  flex-grow: 1;
  overflow-y: scroll;
  height: calc(100% - 54px);
  -ms-overflow-style: auto;
  scrollbar-width: 3px;
}
._wrapper_1c7i7_1 ._list_1c7i7_18::-webkit-scrollbar {
  display: block;
}
._wrapper_1c7i7_1 ._list_1c7i7_18::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  padding: 2px;
}
._wrapper_1c7i7_1 ._list_1c7i7_18::-webkit-scrollbar-track {
  background: #f1f1f1;
}
._wrapper_1c7i7_1 ._list_1c7i7_18::-webkit-scrollbar-thumb {
  background: #3e3f42;
  border-radius: 4px;
}
._wrapper_1c7i7_1 ._list_1c7i7_18::-webkit-scrollbar-thumb:hover {
  background: #3e3f42;
  border-radius: 4px;
}
._wrapper_1c7i7_1 ._list_1c7i7_18 ._item_1c7i7_44 {
  display: flex;
  flex-direction: row;
  border: 1px solid #eaedf3;
  border-top: 0;
}
._wrapper_1c7i7_1 ._list_1c7i7_18 ._item_1c7i7_44:first-of-type {
  border-top: 1px solid #eaedf3;
}
._wrapper_1c7i7_1 ._list_1c7i7_18 ._item_1c7i7_44 ._content_1c7i7_53 {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding: 24px;
  gap: 31px;
}
._wrapper_1c7i7_1 ._list_1c7i7_18 ._item_1c7i7_44 ._content_1c7i7_53 ._a_1c7i7_60 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
._wrapper_1c7i7_1 ._list_1c7i7_18 ._item_1c7i7_44 ._content_1c7i7_53 ._a_1c7i7_60 ._title_1c7i7_65 {
  font-weight: 500;
  font-size: 16px;
  color: #000000;
}
._wrapper_1c7i7_1 ._list_1c7i7_18 ._item_1c7i7_44 ._content_1c7i7_53 ._a_1c7i7_60 ._status_1c7i7_70 {
  font-size: 14px;
  color: #000000;
}
._wrapper_1c7i7_1 ._list_1c7i7_18 ._item_1c7i7_44 ._content_1c7i7_53 ._b_1c7i7_74 {
  display: flex;
  flex-direction: row;
  gap: 30px;
  flex-wrap: wrap;
}
._wrapper_1c7i7_1 ._list_1c7i7_18 ._item_1c7i7_44 ._content_1c7i7_53 ._b_1c7i7_74 ._info_1c7i7_80 {
  display: flex;
  flex-direction: row;
  gap: 5px;
  font-size: 14px;
  color: #000000;
}
._wrapper_1c7i7_1 ._list_1c7i7_18 ._item_1c7i7_44 ._content_1c7i7_53 ._b_1c7i7_74 ._info_1c7i7_80 span {
  color: #9ea0a5;
}
._wrapper_1c7i7_1 ._list_1c7i7_18 ._item_1c7i7_44 ._content_1c7i7_53 ._b_1c7i7_74 ._info_1c7i7_80 ._patientButton_1c7i7_90 {
  color: #1665d8;
  font-weight: 500;
}
._wrapper_1c7i7_1 ._list_1c7i7_18 ._item_1c7i7_44 ._content_1c7i7_53 ._b_1c7i7_74 ._info_1c7i7_80 ._patientButton_1c7i7_90 span {
  color: #1665d8;
}
._wrapper_1c7i7_1 ._list_1c7i7_18 ._item_1c7i7_44 ._controls_1c7i7_97 {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 24px;
  border-left: 1px solid #eaedf3;
  min-width: 180px;
  max-width: 180px;
  flex-wrap: wrap;
}
._wrapper_1c7i7_1 ._list_1c7i7_18 ._item_1c7i7_44 ._controls_1c7i7_97 ._linkBlue_1c7i7_108 {
  font-size: 14px;
  font-weight: 500;
  color: #1665d8;
  text-decoration: underline;
  cursor: pointer;
}
._wrapper_1c7i7_1 ._list_1c7i7_18 ._item_1c7i7_44 ._controls_1c7i7_97 ._linkRed_1c7i7_115 {
  font-size: 14px;
  font-weight: 500;
  color: #d81616;
  text-decoration: underline;
  cursor: pointer;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  